<script>
  import CheckBox from "../../utils/CheckBox.svelte";
  import { saveSettings } from "../../api";
  import {SETTING_SAVE_TYPES} from "../../constants";
  import { PHP, alert } from "../../store";
  import Message from "../../utils/Message.svelte";
  import to from "await-to-js";

  export let submitSettings;

  let inprogress = false;

  let generalSettings = {
    isEnabled: JSON.parse($PHP.settings.webpush_enabled || false)
  };

  let generalErrors = {
    isEnabled: ""
  };

  async function save(event) {
    inprogress = true;

    await to(
      submitSettings(SETTING_SAVE_TYPES.GENERAL, {
        webpush_enabled: generalSettings.isEnabled
      })
    );

    inprogress = false;

    return alert.setWithTimeout({
      value: "Your change successfuly saved",
      className: "is-success",
      timeout: 5000
    });
  }
</script>

<div class="container is-fluid">
  <CheckBox
    title="Enable web push"
    bind:value={generalSettings.isEnabled}
    error={generalErrors.isEnabled}
    disabled={!$PHP.isActivated}
    tooltip={!$PHP.isActivated && 'First you need to activate the plugin'}
    isHorizontal />
  <div class="buttons is-centered">
    <button
      class="button is-success is-outlined"
      on:click={save}
      class:is-loading={inprogress}
      disabled={inprogress}>
      Save
    </button>
  </div>
</div>
